import {Component, OnInit, ViewChild} from '@angular/core';
import { Calendar } from '@fullcalendar/core';
import { CalendarOptions } from '@fullcalendar/angular';
import frLocale from '@fullcalendar/core/locales/fr';

@Component({
  selector: 'app-calendar-planing',
  templateUrl: './calendar-planing.component.html',
  styleUrls: ['./calendar-planing.component.css']
})
export class CalendarPlaningComponent implements OnInit {
  @ViewChild('fullcalendar', { static: false }) fullcalendar: CalendarPlaningComponent;
  events: any[] = [
    {
      title: 'event',
      allDay: false,
      start: '2020-06-22T09:00:00',
      end: '2020-06-22T18:00:00',
    },
    {
      title: 'event',
      allDay: false,
      start: '2020-06-23T09:00:00',
      end: '2020-06-23T18:00:00',
    },
    {
      title: 'event',
      allDay: false,
      start: '2020-06-24T09:00:00',
      end: '2020-06-24T18:00:00',
    },
    {
      title: 'event',
      allDay: false,
      start: '2020-06-25T09:00:00',
      end: '2020-06-25T18:00:00',
    },
    {
      title: 'event',
      allDay: false,
      start: '2020-06-26T09:00:00',
      end: '2020-06-26T18:00:00',
    },
  ];
  name = Calendar.name;
  locales = [frLocale];
  options: CalendarOptions = {
    timeZone: 'UTC',
    locales: this.locales,
    headerToolbar: {
      left: 'dayGridMonth,timeGridWeek,timeGridDay',
      center: 'title',
      right: 'prevYear,prev,next,nextYear'
    },
    footerToolbar: {
      // left: 'custom1,custom2',
      center: '',
      right: 'prev,next'
    },
    initialView: 'timeGridWeek',
    events: this.events,
    navLinks: true, // can click day/week names to navigate views
  };
  constructor() {
  }
  ngOnInit(): void {
  }

}
